import "./Project1.css";

function Project6() {
  return (
    <div className="project1-cont active">
      <div className="project-header">
        <h2>Lensbury</h2>
      </div>
      <div className="about-text">
        <p>
    Lensbury is an innovative custom theme with various custom blocks developed for a travel and hospitality management company. The website has a sleek and user-friendly interface, providing potential clients with an immersive visual experience. The project was implemented using PHP, ACF, CSS, SASS, WordPress, JavaScript, and jQuery.
    Lensbury was developed under the expert supervision and creative direction of Up Hotel Agency.
        </p>
        <h3 className="project-link">
          <a
            href="https://www.lensbury.com/"
            target="_blank"
            rel="noreferrer"
          >
            <span>View Site</span>
          </a>
          <br />
        </h3>
      </div>
    </div>
  );
}

export default Project6;
